import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

function Empprofile() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [data, setData] = useState(null);
  const [username, setUsername] = useState("");
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
    role: "",
  });

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email || decoded.phoneNumber);
      setRole(decoded.role);
      if (decoded.role !== "employee") {
        navigate("/login");
      }
    }
  }, []);

  useEffect(() => {
    axios
      .get(` https://api.easytaxexperts.com/get/details/${username}`)
      .then((response) => {
        setData(response.data);
        setFormData({
          userName: response.data[0].userName || "",
          email: response.data[0].email || "",
          phoneNumber: response.data[0].phoneNumber || "",
          role: response.data[0].role || "",
        });
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [username]);

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <h4>My Profile Details</h4>
            <form className=" mt-2">
              <div className="form-group mb-2">
                <label>User Name:</label>
                <input
                  type="text"
                  value={formData.userName}
                  readOnly
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label>Email:</label>
                <input
                  type="email"
                  value={formData.email}
                  readOnly
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label>Phone Number:</label>
                <input
                  type="text"
                  value={formData.phoneNumber}
                  readOnly
                  className="form-control"
                />
              </div>
            
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empprofile;
